export default __webpack_public_path__ + "b5bd9083378a8acb6b03243769fdf34f.png";